export const getErrorMessage = (error: unknown, fallback = '操作失败，请稍后重试') =>
  error instanceof Error && String(error.message || '').trim() ? error.message : fallback;

const nodeEnv = String(__APP_NODE_ENV__ || 'development').trim() || 'development';
const isDev = nodeEnv !== 'production';
const shouldLogToConsole = isDev && nodeEnv !== 'test';

export const reportClientError = (
  scope: string,
  error: unknown,
  context?: Record<string, unknown>
) => {
  if (!shouldLogToConsole) return;
  const prefix = `[CLIENT:${scope}]`;
  if (context && Object.keys(context).length > 0) {
    console.error(prefix, error, context);
    return;
  }
  console.error(prefix, error);
};
